import { observable } from "@legendapp/state";
import { ObservablePersistLocalStorage } from "@legendapp/state/persist-plugins/local-storage";
import { synced } from "@legendapp/state/sync";

import { authClient } from "~/libs/auth.lib";
import { switchOrgChannel } from "~/libs/pubsub.lib";
import type { ActiveOrganization } from "./organizations.types";

export const activeOrganization$ = observable<ActiveOrganization | null>(
  synced({
    initial: null,
    persist: {
      name: "active-organization",
      plugin: ObservablePersistLocalStorage,
    },
  }),
);

authClient.$store.atoms.activeOrganization.subscribe((state) => {
  if (state.data) {
    activeOrganization$.set(state.data);
  } else if (!state.isPending) {
    activeOrganization$.set(null);
  }
});

activeOrganization$.id.onChange(
  ({ value }) => {
    switchOrgChannel(value ?? null);
  },
  { initial: true },
);
